export default "__VITE_ASSET__ux8D_8QT__"